import { render, staticRenderFns } from "./FilterExpansionPanels.vue?vue&type=template&id=05bbb1ba&scoped=true"
import script from "./FilterExpansionPanels.vue?vue&type=script&lang=js"
export * from "./FilterExpansionPanels.vue?vue&type=script&lang=js"
import style0 from "./FilterExpansionPanels.vue?vue&type=style&index=0&id=05bbb1ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bbb1ba",
  null
  
)

export default component.exports